import { Link } from 'react-router-dom';
import { Instagram, Twitter, Linkedin, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

const COLUMNS = [
  {
    title: 'Product',
    links: [
      { label: 'Creator Hubs', href: '/#hubs', anchor: true },
      { label: 'Ticketing', href: '/#ticketing', anchor: true },
      { label: 'Community', href: '/#community', anchor: true },
      { label: 'Monetization', href: '/#revenue', anchor: true },
      { label: 'Pricing', href: '/pricing' },
    ],
  },
  {
    title: 'Solutions',
    links: [
      { label: 'For Organisers', href: '/#for-organisers', anchor: true },
      { label: 'For Venues', href: '/#for-venues', anchor: true },
      { label: 'How it works', href: '/#how-it-works', anchor: true },
      { label: 'Become a Partner', href: '/partner/register' },
      { label: 'Partner Portal', href: '/partner/dashboard' },
    ],
  },
  {
    title: 'Company',
    links: [
      { label: 'Communities', href: '/creators' },
      { label: 'Guides', href: '/guides' },
      { label: 'Product Feedback', href: '/feedback' },
    ],
  },
];

const Footer = () => (
  <footer className="bg-[#08090d] border-t border-white/[0.08] pt-20 pb-8" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      {/* CTA row */}
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-6 pb-14 border-b border-white/[0.08]">
        <div>
          <p className="text-2xl md:text-3xl font-semibold text-white tracking-tight" style={{ fontFamily: "'Outfit', sans-serif" }}>
            Ready to run your community on one platform?
          </p>
          <p className="text-sm text-zinc-500 mt-2">Free to start. No credit card required.</p>
        </div>
        <Link to="/my-hubs" data-testid="footer-start-free-link">
          <Button className="h-12 px-7 rounded-full bg-white text-[#08090d] hover:bg-zinc-200 font-semibold shrink-0">
            Start free <ArrowRight className="w-4 h-4 ml-2" />
          </Button>
        </Link>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-5 gap-8 py-14">
        <div className="col-span-2">
          <Link to="/" className="inline-block mb-4">
            <span className="text-lg font-bold tracking-wider text-white" style={{ fontFamily: "'Syne', sans-serif" }}>
              EVENT<span className="text-indigo-500">★</span>GOERS
            </span>
          </Link>
          <p className="text-sm text-zinc-500 max-w-xs leading-relaxed mb-6">
            The operating system for event communities. Manage, grow and monetize the crowd that already loves you.
          </p>
          <div className="flex gap-3">
            {[Instagram, Twitter, Linkedin].map((Icon, i) => (
              <a key={i} href="#" className="w-9 h-9 rounded-full border border-white/10 flex items-center justify-center text-zinc-500 hover:text-white hover:border-white/25 transition-colors">
                <Icon className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>

        {COLUMNS.map((col) => (
          <div key={col.title}>
            <h4 className="text-xs font-semibold uppercase tracking-[0.16em] text-zinc-500 mb-4">{col.title}</h4>
            <ul className="space-y-2.5">
              {col.links.map((link) => (
                <li key={link.label}>
                  {link.anchor ? (
                    <a href={link.href} className="text-sm text-zinc-400 hover:text-white transition-colors">{link.label}</a>
                  ) : (
                    <Link to={link.href} className="text-sm text-zinc-400 hover:text-white transition-colors">{link.label}</Link>
                  )}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="pt-8 border-t border-white/[0.08] flex flex-col sm:flex-row justify-between items-center gap-3">
        <p className="text-xs text-zinc-600">© {new Date().getFullYear()} EVENT★GOERS. All rights reserved.</p>
        <p className="text-xs text-zinc-600">Built in Denver, Colorado</p>
      </div>
    </div>
  </footer>
);

export default Footer;
